
/**
 * A simple loading spinner component using Tailwind CSS.
 * @param {object} props - Component props.
 * @param {'small' | 'large'} [props.size='large'] - The size of the spinner.
 */
function LoadingSpinner({ size = 'large' }) {

  // Determine Tailwind classes based on the size prop
  const sizeClasses = size === 'small'
    ? 'w-5 h-5 border-4'   // 20px width/height, 4px border width
    : 'w-12 h-12 border-8';  // 48px width/height (closest to 50px), 8px border width

  // Combine base styles, size-specific styles, and animation
  const spinnerClasses = `
    ${sizeClasses}
    rounded-full                // Makes it a circle
    border-solid                // Sets border style
    border-gray-200             // Base border color (light grey)
    border-t-blue-500           // Top border color (blue) - creates the effect
    animate-spin                // Applies the spin animation (1s linear infinite)
    mx-auto                     // Centers horizontally
    my-5                        // Vertical margin (20px)
  `;

  // No need for external CSS @keyframes, animate-spin handles it.
  return <div className={spinnerClasses.trim()}></div>;
}

export default LoadingSpinner;